import { axiosInstance as axios, handleAxiosErrors } from '../_utils';
import {
    convertPICNumberListingToAReadableFormat,
    convertUserDetailedInformationToAReadableFormat,
} from '../selectors/converterSelector';
import config from '../store/_config';
// import { createAlert } from "../dom/window";

export const toggleLoading = (key, value) => {
    return {
        type: 'TOGGLE_PIC_NUMBER_LOADING',
        key: key,
        value: value,
    };
};
export const toggleRowLoading = (key, identifier, value) => {
    return {
        type: 'TOGGLE_PIC_NUMBER_ROW_LOADING',
        key: key,
        identifier: identifier,
        value: value,
    };
};
export const replacePICNumberList = (value) => {
    return {
        type: 'REPLACE_PIC_NUMBER_LIST',
        value: value,
    };
};
export const requestPICNumbers = (params) => {
    return (dispatch, getState) => {
        // const state = getState();

        let { url, query } = config.picNumber.listing;
        const showLoading =
            typeof params != 'undefined' &&
                typeof params.withLoading != 'undefined'
                ? params.withLoading
                : true;

        if (showLoading) {
            dispatch(toggleLoading('list', true));
        }

        return axios
            .get(url, {
                withCredentials: true,
                params: {
                    query: query,
                },
            })
            .then((response) => {
                const userInfo = convertUserDetailedInformationToAReadableFormat(
                    response.data.data.readOneMember
                );

                // wait for async requests
                Promise.all([
                    dispatch(
                        replacePICNumberList(userInfo.availablePICNumbers)
                    ),
                ]).then(() => {
                    dispatch(toggleLoading('list', false));
                });
            })
            .catch((error) => handleAxiosErrors(error));
    };
};
export const makeDefault = (identifier) => {
    return (dispatch, getState) => {
        const state = getState();

        let { url, query } = config.picNumber.makeDefault;
        let data = {
            id: query,
            variables: {
                Input: {
                    ID: identifier,
                    IsDefault: true,
                },
            },
        };

        dispatch(toggleRowLoading('IsDefault', identifier, true));

        return axios
            .post(url, data, {
                withCredentials: true,
            })
            .then((response) => {
                Promise.all([
                    dispatch(requestPICNumbers({ withLoading: false })),
                ]).then(() => {
                    dispatch(toggleRowLoading('IsDefault', identifier, false));
                });
            })
            .catch((error) => {
                dispatch(toggleRowLoading('IsDefault', identifier, false));
                handleAxiosErrors(error);
            });
    };
};
export const removePICNumber = (identifier) => {
    return (dispatch, getState) => {
        const state = getState();

        let { url, query } = config.picNumber.delete;
        let data = {
            id: query,
            variables: {
                ID: identifier,
            },
        };

        dispatch(toggleRowLoading('IsDelete', identifier, true));

        return axios
            .post(url, data, {
                withCredentials: true,
            })
            .then((response) => {
                Promise.all([
                    dispatch(requestPICNumbers({ withLoading: false })),
                ]).then(() => {
                    dispatch(toggleRowLoading('IsDelete', identifier, false));
                });
            })
            .catch((error) => {
                dispatch(toggleRowLoading('IsDelete', identifier, false));
                handleAxiosErrors(error);
            });
    };
};
export const submitPICNumber = (formData, callback) => {
    return (dispatch, getState) => {
        const state = getState();

        let { url, query } = config.picNumber.create;
        let data = {
            id: query,
            variables: {
                Input: formData,
            },
        };

        dispatch(toggleLoading('form', true));

        return axios
            .post(url, data, {
                withCredentials: true,
            })
            .then((response) => {
                // Flush Form
                dispatch(toggleLoading('form', false));

                // Re-request category
                dispatch(requestPICNumbers());

                if (
                    typeof callback != 'undefined' &&
                    typeof callback.success != 'undefined'
                ) {
                    callback.success();
                }
            })
            .catch((error) => {
                dispatch(toggleLoading('form', false));
                handleAxiosErrors(error);
            });
    };
};
export const axiosRequestPICNumbers = (id = 0, orderOnBehalf) => {
    let { url, query } = config.picNumber.listing;

    if (id > 0) {
        query = query.replace('readOneMember', `readOneMember(ID: ${id})`);
    }

    if (orderOnBehalf) {
        query = query.replace('readOneMember', `readOneMember(PurchasingUser: true)`);
    }

    return axios.get(url, {
        withCredentials: true,
        params: {
            query: query,
        },
    });
};
export const axiosCreatePICNumber = (formData, memberID = null, orderOnBehalf = false) => {
    let { url, query } = config.picNumber.create;
    let data = {
        id: query,
        variables: {
            Input: formData,
        },
    };

    if (memberID != null) {
        data.variables.MemberID = memberID;
    }

    if (orderOnBehalf) {
        data.variables.PurchasingUser = true;
    }

    return axios.post(url, data, {
        withCredentials: true,
    });
};
export const axiosUpdatePICNumber = (formData, memberID = null, orderOnBehalf = false) => {
    let { url, query } = config.picNumber.update;
    let data = {
        id: query,
        variables: {
            Input: formData,
        },
    };

    if (memberID != null) {
        data.variables.MemberID = memberID;
    }

    if (orderOnBehalf) {
        data.variables.PurchasingUser = true;
    }

    return axios.post(url, data, {
        withCredentials: true,
    });
};
export const axiosDeletePICNumber = (identifier, memberID = null) => {
    let { url, query } = config.picNumber.delete;
    let data = {
        id: query,
        variables: {
            ID: identifier,
        },
    };

    if (memberID != null) {
        data.variables.MemberID = memberID;
    }

    return axios.post(url, data, {
        withCredentials: true,
    });
};
export const axioxMakeDefaultPICNumber = (identifier, memberID = null) => {
    let { url, query } = config.picNumber.makeDefault;
    let data = {
        id: query,
        variables: {
            Input: {
                ID: identifier,
                IsDefault: true,
            },
        },
    };

    if (memberID != null) {
        data.variables.MemberID = memberID;
    }

    return axios.post(url, data, {
        withCredentials: true,
    });
};

export const axiosReadLastSequenceNumber = () => {
    let { url, query } = config.picNumber.lastSequenceNumber;

    return axios.get(url, {
        withCredentials: true,
        params: {
            query: query,
        },
    });
};

export const axiosReadLastSequenceNumberWithPrefix = (prefix = '', PICNumber = "", PostBreederLetter = "", ContinueSequence = true, BuyableID = 0) => {
    let { url, query } = config.picNumber.lastSequenceNumberWithPrefix;

    if (prefix != '' || prefix != null) {
        query = query.replace(/{Prefix}/, `"${prefix}"`);
    }
    else {
        query = query.replace('Prefix: {Prefix},', '');
    }

    query = query.replace(/{PICNumber}/, `"${PICNumber}"`);
    query = query.replace(/{PostBreederLetter}/, `"${PostBreederLetter}"`);
    query = query.replace(/{ContinueSequence}/, `${ContinueSequence ? true : false}`);
    query = query.replace(/{BuyableID}/, Number(BuyableID));

    return axios.get(url, {
        withCredentials: true,
        params: {
            query: query,
        },
    });
};
